import React from 'react'
import { Text } from 'rebass'
import styled from 'styled-components'

const AppleBox = styled.div`
  max-width: 420px;
  padding-top: 24px;
  color: ${({theme}) => theme.bsText3};
  text-align: justify;
  a {
    color: ${({theme}) => theme.bsText12};
  }
`

export default function Apply() {
  return (
    <AppleBox>
      <Text fontSize={15}>
        We will automatically add the logos of the tokens with TVL (BNB or BAKE pair) higher than $1 million to the exchange list. {' '}
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSeMzAIg2gkNI0fHc1ULHEWPRk6XS-RjZ58jDIHYHkKHoEz9rA/viewform?usp=sf_link" target="_blank" rel="noopener noreferrer">
          Submit your contract address and logo here
        </a>
      </Text>
    </AppleBox>
  )
}